/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Align_Center_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Align text center" |
*
* @param {Align_Center_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const align_center_aria_label = /** @type {((inputs?: Align_Center_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Align_Center_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aligner le texte au centre")
	if (locale === "de") return /** @type {LocalizedString} */ ("Text zentrieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Allinea il testo al centro")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выровнять текст по центру")
	if (locale === "es") return /** @type {LocalizedString} */ ("Alinear el texto al centro")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("文本居中对齐")
	if (locale === "ja") return /** @type {LocalizedString} */ ("テキストを中央揃え")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टेक्स्ट को केंद्र में संरेखित करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Alinhar texto ao centro")
	return /** @type {LocalizedString} */ ("Align text center")
});